<template>
    <div v-html="getRoleAndColor(roleId, roleName)"></div>
</template>

<script>
export default {
    props: {
        roleId: Number,
        roleName: String,
    },
    data() {
        return {
            roleColors: ['bg-blue', 'bg-light-blue', 'bg-yellow', 'bg-gray', 'bg-green'],
        };
    },
    methods: {
        getRoleAndColor: function (roleId, roleName) {
            roleName = roleName.charAt(0).toUpperCase() + roleName.slice(1).toLowerCase();
            if (roleId) {
                return '<span class="label ' + this.roleColors[roleId - 1] + '">' + roleName + '</span>';
            }
        },
    },
};
</script>
